function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.732209 17.6H19.8966C20.0685 17.6 20.2346 17.5399 20.3664 17.4303C20.5504 17.2761 24.7494 13.664 25.0054 5.8667H4.42321C4.16816 12.9445 0.301157 16.2713 0.26097 16.3045C0.0253753 16.5036 -0.0613045 16.8287 0.0446864 17.1181C0.149944 17.4066 0.424259 17.6 0.732209 17.6V17.6Z",
  fill: "#D3D2D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2961 1.46666H20.6295V0.733331C20.6295 0.322666 20.3068 0 19.8961 0C19.4855 0 19.1628 0.322666 19.1628 0.733331V1.46666H15.4472V0.733331C15.4472 0.322666 15.1246 0 14.7139 0C14.3032 0 13.9806 0.322666 13.9806 0.733331V1.46666H10.3139V0.733331C10.3139 0.322666 9.99125 0 9.58059 0C9.16992 0 8.84726 0.322666 8.84726 0.733331V1.46666H5.1806C4.76993 1.46666 4.44727 1.78933 4.44727 2.19999V4.39999H25.0294V2.19999C25.0294 1.78933 24.7068 1.46666 24.2961 1.46666Z",
  fill: "#D3D2D2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3086 18.5547C20.9104 18.8862 20.4106 19.0667 19.8971 19.0667H4.44824V21.2667C4.44824 21.6721 4.77624 22 5.18157 22H24.2971C24.7024 22 25.0304 21.6721 25.0304 21.2667V13.0463C23.6166 16.515 21.6436 18.2743 21.3086 18.5547Z",
  fill: "#D3D2D2"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1de164bb8d46390f6ccb8afe16547b2b.svg";
export { ForwardRef as ReactComponent };